import { styled } from 'linaria/react';

export const PointsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-50);
`;

export const PointsAndRankWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-25);

  &:hover {
    div span {
      color: var(--secondary-black) !important;
    }

    svg path {
      fill: var(--control-hover-accent) !important;
    }
  }

  &:before {
    width: 21px;
    height: 20px;
    cursor: pointer;
    content: '';
    position: absolute;
    transform: scale(3);
    right: 19px;
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;
    z-index: 1;
  }
`;

export const Skeleton = styled.div<{ width: number; height: number; radius: number }>`
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;

  @keyframes progress {
    from {
      background-position-x: 0%;
    }
    to {
      background-position-x: 100%;
    }
  }

  border-radius: ${(props) => props.radius}px;

  background: linear-gradient(
    90deg,
    var(--background-secondary),
    var(--background-primary),
    var(--background-secondary)
  );
  background-size: 50%;
  animation: progress 1s linear infinite;
`;
